import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCardContext } from '../contexts/CardContext';
import { StatusPageLayout } from '../components/layout/StatusPageLayout';
// @mcc-dev-preview:import
import { parseDevState } from '../dev/devPreview';

// @mcc-dev-preview:start redirect-to-activation-dev-state
const REDIRECT_TO_ACTIVATION_DEV_STATES = ['redirecting'] as const;
// @mcc-dev-preview:end redirect-to-activation-dev-state

const RedirectToActivation: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { cardId } = useCardContext();
  const finalCardId = cardId || searchParams.get('cardId');
  // @mcc-dev-preview:start redirect-to-activation-dev-state
  const devState = parseDevState(searchParams, REDIRECT_TO_ACTIVATION_DEV_STATES);
  // @mcc-dev-preview:end redirect-to-activation-dev-state

  useEffect(() => {
    // @mcc-dev-preview:start redirect-to-activation-dev-state
    if (devState) return;
    // @mcc-dev-preview:end redirect-to-activation-dev-state

    if (finalCardId) {
      navigate(`/card-activation?cardId=${finalCardId}`);
    } else {
      navigate('/card-activation');
    }
  }, [finalCardId, navigate, devState]);

  return (
    <StatusPageLayout
      variant="loading"
      title="Redirecting"
      body="Please wait while we redirect you to card activation."
    />
  );
};

export default RedirectToActivation;
